export const JWT = () => {
    return {
        headers: {
            token: localStorage.getItem('userToken'),
            'x-ray-device': 'WEB'
        }
    }
}

const getServerId = (str) => {
    var n = localStorage.getItem("serverId");
    if (n && n !== "undefined") {
        str = str.indexOf("localhost") > -1 ? "https://apidev.raysmiler.co.kr/api" : str;
        var arr = str.split('.');
        arr[0] = arr[0] + "-" + n;
        return arr.join(".");
    }
    return str;
}
export const AppConfig = {
    APP_NAME: process.env.REACT_APP_APPNAME || "",
    API_SERVER_PATH_V2: getServerId(process.env.REACT_APP_API_SERVER_PATH_V2),
    API_SERVER_PATH_OLD: "https://apidev.raysmiler.co.kr/api",
    API_SERVER_PATH_RAYLINKLOCAL: getServerId(process.env.REACT_APP_API_SERVER_PATH_OLD),
    SERVER_STATICS_PATH: getServerId(process.env.REACT_APP_SERVER_STATICS_PATH),
    WS_PATH: "wss://apidev.raysmiler.co.kr/",
    S3_PATH: process.env.REACT_APP_S3_PATH,
    RAYCLOUD_PATH: process.env.REACT_APP_RAYCLOUD_PATH,
    RAYCLOUD_APPNAME: process.env.REACT_APP_RAYCLOUD_APPNAME,
    RAYCLOUD_APPUSERNAME: process.env.REACT_APP_RAYCLOUD_APPUSERNAME,
    RAYCLOUD_APPTOKEN: process.env.REACT_APP_RAYCLOUD_APPTOKEN,
    LOCALE_PATH: process.env.REACT_APP_LOCALE_PATH,
    LOCALE_API: process.env.REACT_APP_LOCALE_API,
    EZCHECK_VIEW: getServerId(process.env.REACT_APP_EZCHECK_VIEWER),
    EZCHECK_API: getServerId(process.env.REACT_APP_EZCHECK_API),
    API_SERVER_PATH: process.env.REACT_APP_API_SERVER_PATH_NEW,
    GOOGLE_MAP_KEY: process.env.REACT_APP_GOOGLE_MAP_KEY,
    PRIVACY_LINK: process.env.REACT_APP_PRIVACY_LINK,
    DYNAMO_DB_ACCESS_KEY: process.env.REACT_APP_DYNAMO_DB_ACCESS_KEY,
    DYNAMO_DB_SECRET_KEY: process.env.REACT_APP_DYNAMO_DB_SECRET_KEY,
    MAIL_SEND_ACCESS_KEY: process.env.REACT_APP_MAIL_SEND_ACCESS_KEY,
    MAIL_SEND_SECRET_KEY: process.env.REACT_APP_MAIL_SEND_SECRET_KEY,
    S3_ACCESS_KEY: process.env.REACT_APP_S3_ACCESS_KEY,
    S3_SECRET_KEY: process.env.REACT_APP_S3_SECRET_KEY,
    S3_BUCKET_NAME: process.env.REACT_APP_S3_BUCKET_NAME,
    PAYPAL_CLIENT_ID: process.env.REACT_APP_PAYPAL_CLIENT_ID,
    PAYPAL_SECRET_KEY: process.env.REACT_APP_PAYPAL_SECRET_KEY
};
